/* eslint-disable no-undef */
import React from 'react';
import { send } from 'server';
import { getId } from 'js/hooks/device';
import * as pas from 'js/hooks/auth/pas';
import { dispatcher } from './dispatcher';
import { createRoot } from 'react-dom/client';
import { registerPortlets } from './portlets';
import { scrollService } from 'js/services/scroll.service';
import { ReCaptchaBare, ERRORS } from 'js/components/main/ReCaptcha';
import { addBackUrls } from 'js/components/main/QuickDeposit/Deposit/helpers';
import { performRedirect } from 'js/components/main/QuickDeposit/utils/redirect';

export { pas };
export { dispatcher };
export { registerPortlets };
export { send };

export const getDeviceId = () => getId();
export const cashier = {
    addBackUrls,
    performRedirect
};
export const {
    enableBodyScroll,
    disableBodyScroll
} = scrollService;

export const reCaptcha = selector => {
    let root;

    return {
        render: options => {
            root = createRoot(document.querySelector(selector));

            root.render(<ReCaptchaBare {...options} />);
        },
        remove: () => root && root?.unmount(),
        ERRORS
    };
};
